import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import RegionalSupport from "./RegionalSupport";
import GeneralInfo from "./GeneralInfo";
import DynamicTable from "./DynamicTable";
import DynamicRow from "./DynamicRow";
import StoreVisitTab from "./StoreVisitTab";
import { loadSearchSAPGetDataRequest } from "../redux/Actions";
import Loader from "../../../shared/components/Loader";
import jsonData from "./data.json";
import { useSearchParams } from "react-router-dom";
import DefaultButton from "../../../shared/components/DefaultButton";
import { SUBMIT } from "../../../shared/constants/Constants";


const SearchSAP = () => {
    let dispatch = useDispatch();
    let navigate = useNavigate();

    const [flag, setFlag] = useState(false);
    const [sap, setSAP] = useState();
    const [storeData, setstoreData] = useState([]);
    const [currentTab, setCurrentTab] = useState('General Info');
    const [searchParams] = useSearchParams();
    const sapFromUrl = searchParams.get("sap");

    let { searchsap, error, loading } = useSelector((state) => state.searchsap);

    useEffect(() => {
        if (sapFromUrl) {
            setSAP(sapFromUrl);
            setFlag(true);
            setCurrentTab("General Info");
            dispatch(loadSearchSAPGetDataRequest(sapFromUrl));
        }
    }, [sapFromUrl, dispatch]);

    const handleSAP = () => {
        setFlag(true);
        setCurrentTab('General Info');
        dispatch(loadSearchSAPGetDataRequest(sap));
    };

    const handleEnterPress = (event) => {
        if (event.key === 'Enter') {
            setFlag(true);
            setCurrentTab('General Info');
            dispatch(loadSearchSAPGetDataRequest(sap));
        }
    };

    console.log("dispatch", dispatch);
    console.log(searchsap?.general_info?.sap);
    console.log(storeData?.network_columns);

    let tabs = {
        "General Info": <GeneralInfo info={searchsap?.general_info} additional_info={searchsap?.other_devices} />,
        ...(searchsap?.asset
            ? { 'Asset Protection': <DynamicRow info={searchsap?.asset?.data} columns={searchsap?.asset?.columns} /> }
            : {}),
        'Regional Support': <RegionalSupport info={searchsap?.region_support} />,
        'Employee Work Week': <DynamicTable info={searchsap?.employee_work_week?.data} columns={searchsap?.employee_work_week?.columns} />,
        'Store Visit': <StoreVisitTab storeSap={searchsap?.general_info?.id} />,
    };

    console.log("searchsap", error);

    return (
        <>
            <Row>
                <Col>
                    <Breadcrumbs
                        children={[
                            { label: "Search SAP" },
                        ]}
                    />
                </Col>
            </Row>
            <Row>
                <Col></Col>
                <Col>
                    <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Enter SAP"
                        value={sap}
                        onChange={(e) => setSAP(e.target.value)}
                        onKeyDown={handleEnterPress}
                    />
                </Col>
                <Col>
                    <DefaultButton
                        buttonClass="default-btn-color mb-3"
                        buttonTitle={SUBMIT}
                        actionBlock={handleSAP}
                    />
                </Col>
                <Col></Col>
            </Row>
            {flag && (
                <Row>
                    {error ? (
                        <div className="alert alert-danger text-center mt-5" role="alert">
                            <p className="mb-1">{error.msg}</p>
                        </div>
                    ) : (
                        <>
                            <Col>
                                {Object.keys(tabs).map(tab =>
                                    <button
                                        key={tab}
                                        className={currentTab === tab ? "top-tab selected" : "top-tab"}
                                        onClick={() => setCurrentTab(tab)}
                                    >
                                        {tab}
                                    </button>
                                )}
                            </Col>
                            <Card>
                                <Card.Body>
                                    {tabs[currentTab]}
                                </Card.Body>
                            </Card>
                        </>
                    )}
                </Row>
            )}
        </>
    );
};

export default SearchSAP;
